import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListUsers from '../../components/admin-users/list-users.component';

const AdminUsersView = () => {
  const pageTitle = 'Settings / User Permissions';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListUsers />
    </AppLayout>
  );
};

export default AdminUsersView;
